<template>
  <div
    class="modal fade "
    id="signin-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered signup-modal"
      role="document"
    >
      <div class="modal-content ">
        <div class="modal-header">
          <h3
            class="modal-title login-modal-title"
            id="exampleModalLongTitle"
          >
            Sign Up
          </h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
              @click.prevent="resetRegisterFormData()"
              id="sign-up-close"
            >
              &times;
            </span>
          </button>
        </div>
        <div
          class="modal-body login-modal-body"
          v-show="(!signUpFormSubmitted)"
        >
          <p
            class="text-left"
            id="sign-up-para"
          >
            Please enter your details to Sign Up.
          </p>
          <sign-up-form
            :accountData=account
            @signUpFormSubmit="signUpSubmitAction($event)"
            :loading="loading"
          >
          </sign-up-form>
        </div>
        <div
          class="modal-body login-modal-body"
          v-show="(signUpFormSubmitted && !optVerified)"
        >
          <p
            class="text-left"
            id="sign-up-verification-para"
          >
            Please enter verification code (OTP) sent to:
          </p>
          <verify-otp-form
            :formData=verifyOptFormData
            @cancelOtp="signUpFormSubmitted = false"
            @resendOtp="checkOtpOptionAndSendOtp()"
            @verifyOtp="verifyOtp($event)"
            :loading="loading"
          >
          </verify-otp-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import SocialMediaSignUp from '@/components/shared/modals/widgets/SocialMediaSignUp'
import SignUpForm from '@/components/pages/signUp/forms/SignUpForm'
import VerifyOtpForm from '@/components/pages/signUp/forms/VerifyOtpForm'
import { authenticationApi } from '@/services/ApiServices/authenticationApi'

export default {
	components: {
		// SocialMediaSignUp,
		SignUpForm,
		VerifyOtpForm
	},
	data () {
		return {
			account: {
				firstname: '',
				lastname: '',
				username: '',
				password: '',
				phoneno: '',
				confirmPassword: '',
				checkbox: false,
				otpOption: 'phone'
			},
			verifyOptFormData: {
				otpAgent: '',
				phoneno: '',
				email: ''
			},
			signUpFormSubmitted: false,
			optVerified: false,
			loading: ''
		}
	},
	methods: {
		signUpSubmitAction (accountData) {
			authenticationApi.userVerification(accountData.username)
				.then((res) => {
					this.checkOtpOptionAndSendOtp(accountData)
				}).catch((e) => {
					this.resetRegisterFormData()
					//   $('#login-modal').modal('show');
					this.$router.push('/login')
				})
		},
		checkOtpOptionAndSendOtp (accountData) {
			let userAccountData = this.account
			if (accountData) {
				userAccountData = accountData
			}
			if (userAccountData.otpOption.toLowerCase() === 'email') {
				// call email otp service
				this.loading = authenticationApi.sendOTPEmail(userAccountData.username).then((res) => {
					this.sendOtpSuccessCase(userAccountData)
				})
			} else if (userAccountData.otpOption.toLowerCase() === 'phone') {
				// call phone otp service
				this.loading = authenticationApi.sendOTP(userAccountData.phoneno).then((res) => {
					this.sendOtpSuccessCase(userAccountData)
				})
			}
		},
		sendOtpSuccessCase (accountData) {
			this.signUpFormSubmitted = true
			this.account = accountData
			this.verifyOptFormData = {
				otpAgent: accountData.otpOption,
				phoneno: accountData.phoneno,
				email: accountData.username
			}
		},
		verifyOtp (optDetails) {
			if (optDetails.otpAgent.toLowerCase() === 'email') {
				// call email otp verification service
				this.loading = authenticationApi.verifyOTPEmail(optDetails.otp).then((res) => {
					this.signUp()
				})
			} else if (optDetails.otpAgent.toLowerCase() === 'phone') {
				// call phone otp verification service
				this.loading = authenticationApi.verifyOTP(optDetails.otp).then((res) => {
					if (res.data.message === 'OTP Expired') {
						this.$toasted.show('Current OTP is Expired', { icon: 'exclamation-circle' })
					} else {
						this.signUp()
					}
				})
			}
		},
		resetRegisterFormData () {
			this.account = {
				firstname: '',
				lastname: '',
				username: '',
				password: '',
				phoneno: '',
				confirmPassword: '',
				otpOption: 'phone',
				checkbox: false
			}
			this.signUpFormSubmitted = false
			this.optVerified = false
			this.$root.$emit('SignUpFormClear')
			this.$root.$emit('ResetVerifyOtp')
			$('#signin-modal').modal('hide')
		},
		signUp () {
			this.loading = authenticationApi.signUp(this.account).then((res) => {
				if (res.status === 201) {
					this.resetRegisterFormData()
				}
			}).catch((e) => {
				if (e.status === 409) {
					this.resetRegisterFormData()
					//   $('#login-modal').modal('show');
					this.$router.push('/login')
				}
			})
		}

	}
}
</script>
